module.exports = __webpack_public_path__ + "img/11_ok.f0f3b835.png";